import styled from "styled-components";

import { StyledIntentButtonWrapper, StyledIntentContentWithIcon, StyledIntentIcon } from "../../IntentBanner/styles";
import BaseIntentEmptyTopicsBanner from "../BaseIntentEmptyTopicsBanner";

const ICON_SIZE_Y = 32;
const BUTTON_WRAP_X = 12;

export const StyledIntetEmptyTopicsBanner = styled(BaseIntentEmptyTopicsBanner)`
    padding: 10px 16px;
    box-sizing: border-box;

    & ${StyledIntentContentWithIcon} {
        align-items: flex-start;
        user-select: none;
        white-space: pre-line;
    }

    & ${StyledIntentIcon} {
        margin-right: 8px;
    }

    & ${StyledIntentButtonWrapper} {
        margin-top: -${BUTTON_WRAP_X}px;
        margin-left: ${ICON_SIZE_Y}px;
    }
`;
